import * as React from "react";
import classnames from "classnames";
import { Text, Heading } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import LoadingStoreCard from "../../../../LoadingStoreCard/v3/components/LoadingStoreCard/LoadingStoreCard.js";
import AlternativeStoreItem from "./AlternativeStoreItem.js";
/* empty css                                 */
const AlternativeStoreSuggestions = React.forwardRef(
  ({
    className,
    labels,
    uiState,
    stores,
    getTimeslotLabel,
    onClickPromptCta,
    onClickNoStoresAvailableCta,
    onClickStore,
    ...rest
  }, ref) => {
    return /* @__PURE__ */ React.createElement("div", { className: classnames("alternative-store-suggestions", className), ref, ...rest }, uiState === "prompt-for-stores" ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Text, { component: "p" }, labels.prompt), /* @__PURE__ */ React.createElement("button", { onClick: onClickPromptCta, type: "button" }, /* @__PURE__ */ React.createElement(Text, { variant: "link", className: "alternative-store-suggestions__link" }, labels.promptCta))) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Heading,
      {
        component: "h4",
        variant: "subheading1",
        className: "alternative-store-suggestions__section-title"
      },
      labels.title
    ), uiState === "loading-stores" && /* @__PURE__ */ React.createElement("div", { className: "alternative-store-suggestions__cards-container" }, Array.from({ length: 3 }).map((_, i) => /* @__PURE__ */ React.createElement(LoadingStoreCard, { key: i }))), uiState === "stores-available" && /* @__PURE__ */ React.createElement("div", { className: "alternative-store-suggestions__cards-container" }, stores?.map((item) => /* @__PURE__ */ React.createElement(
      AlternativeStoreItem,
      {
        key: item.store.globalStoreId,
        item,
        getTimeslotLabel,
        onClickStore
      }
    ))), uiState === "no-stores-available" && /* @__PURE__ */ React.createElement("div", { className: "alternative-store-suggestions__no-stores-available" }, /* @__PURE__ */ React.createElement(Alert, { variant: "info", title: labels.noStoresAvailable, className: "alert-m-default" }, /* @__PURE__ */ React.createElement("button", { onClick: onClickNoStoresAvailableCta, type: "button" }, /* @__PURE__ */ React.createElement(Text, { variant: "link", className: "alternative-store-suggestions__link" }, labels.noStoresAvailableCta))))));
  }
);
export {
  AlternativeStoreSuggestions as default
};
//# sourceMappingURL=AlternativeStoreSuggestions.js.map
